import { initAnalyticsPlugin } from '@academica-box/plugins/analytics.client'

export default defineNuxtPlugin(initAnalyticsPlugin)
